import type { Message } from './types';
import { MessageBubble } from './MessageBubble';

interface MessageItemProps {
  message: Message;
  onDiscountResponse: (
    messageId: string,
    action: 'approved' | 'declined',
    newPrice?: number
  ) => void;
  editingDiscount: { messageId: string | null; newPrice: string };
  setEditingDiscount: (state: {
    messageId: string | null;
    newPrice: string;
  }) => void;
}

export function MessageItem({ message }: MessageItemProps) {
  // For now, just render the message bubble
  // Discount logic can be added later if needed
  return <MessageBubble message={message} />;
}
